import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguagePackService {
  private LanguagePack;
  constructor() { }

  public setLanguagePack(value) {
    this.LanguagePack = value;
  }

  public getLanguagePack() {
    return this.LanguagePack;
  }
}


